import React from "react";
import { blockHeading } from "../../../../constans/controlToolbar";
import { objToolbar } from "../../../../constans/controlToolbar";
import styles from '../EditorToolbar.module.scss'
import { Tooltip } from "antd";
import ControlBtn from "../../ControlBtn/ControlBtn"

const BlockHeadingButton = ({ onClick, blockType }) => {
  return (
    <div className={styles.container} style={{ gap: '8px' }}>
          {objToolbar[blockHeading]?.map((type) => (
            <Tooltip key={type.inlineStyle} title={type.tooltipTitle}>
              <ControlBtn
                content={type.content}
                active={type.inlineStyle === blockType}
                inlineStyle={type.inlineStyle}
                onClick={onClick}
              />
            </Tooltip>
          ))}
        </div>
  )
}

export default BlockHeadingButton;